export { default } from './InfoBar'
